export const addNonBreakingSpaces = (text: string): string => {
  if (!text) return text

  const prepositions = [
    'в', 'на', 'с', 'по', 'за', 'из', 'от', 'до', 'для', 'при', 'про', 'без', 'под', 'над',
    'о', 'об', 'обо', 'со', 'во', 'ко', 'к', 'у', 'и', 'а', 'но', 'или'
  ]

  let result = text
  const nonBreakingSpace = '\u00A0'

  prepositions.forEach((prep) => {
    const regex = new RegExp(`(\\s|^)(${prep})\\s`, 'gi')
    result = result.replace(regex, (match, spaceOrStart, prepWord) => {
      const prefix = spaceOrStart === '' ? '' : spaceOrStart
      return `${prefix}${prepWord}${nonBreakingSpace}`
    })
  })

  return result
}

export const addNonBreakingSpaces = (text: string): string => {
  if (!text) return text

  const prepositions = [
    'в', 'на', 'с', 'по', 'за', 'из', 'от', 'до', 'для', 'при', 'про', 'без', 'под', 'над',
    'о', 'об', 'обо', 'со', 'во', 'ко', 'к', 'у', 'и', 'а', 'но', 'или'
  ]

  let result = text
  const nonBreakingSpace = '\u00A0'

  prepositions.forEach((prep) => {
    const regex = new RegExp(`(\\s|^)(${prep})\\s`, 'gi')
    result = result.replace(regex, (match, spaceOrStart, prepWord) => {
      const prefix = spaceOrStart === '' ? '' : spaceOrStart
      return `${prefix}${prepWord}${nonBreakingSpace}`
    })
  })

  return result
}

